module.exports = __webpack_public_path__ + "static/media/shopware_certified_developer_adv.03f21e81.svg";